module.exports = __webpack_public_path__ + "4f506f41e0d52cf7cc8b9326974ed579.svg";